import { render, staticRenderFns } from "./productEditDescription.vue?vue&type=template&id=5e249e69&scoped=true"
import script from "./productEditDescription.vue?vue&type=script&lang=js"
export * from "./productEditDescription.vue?vue&type=script&lang=js"
import style0 from "./productEditDescription.vue?vue&type=style&index=0&id=5e249e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e249e69",
  null
  
)

export default component.exports